<template>
  <canvas
    ref="imageSwitchCanvas"
    style="position: absolute; width: 100%; height: 100%"
    v-if="this.input.customized.static_image || this.input.customized.images.length > 0"
  ></canvas>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "KoioteImageSwitch",

  props: {
    input: Object,
  },

  data() {
    return {
      load_end: false,
      static_loaded: false,
      image: null,
      imageWidth: null,
      imageHeight: null,
      images: [],
    };
  },

  computed: {
    ...mapState(["editing"]),

    value() {
      try {
        const retrievedValue = this.actualPage()
        .global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        .customized.vartable.find((v) => v.formatted_address == this.input.customized.address)?.value;
      const applicableRetrievedValue = retrievedValue == null || isNaN(retrievedValue) ? 0 : retrievedValue;
      return typeof applicableRetrievedValue === "boolean" ? +applicableRetrievedValue : applicableRetrievedValue;
  
      } catch (error) {
        return '?'
      }
   },
  },

  methods: {
    ...mapGetters(["actualPage"]),

    loadStaticImage() {
      if (this.input.customized.static_image) {
        const imageLoader = new Image();
        imageLoader.onload = () => {
          this.image = imageLoader;
          this.imageWidth = imageLoader.naturalWidth;
          this.imageHeight = imageLoader.naturalHeight;
          this.static_loaded = true;
        };
        imageLoader.src = this.input.customized.static_image;
      }
    },

    loadAndDraw(index) {
      const imageLoader = new Image();
      imageLoader.onload = async () => {
        const set_value = this.input.customized.set_values[index];
        const imageData = {
          object_index: this.input.id_draggable,
          index: this.images.length,
          image: imageLoader,
          width: imageLoader.naturalWidth,
          height: imageLoader.naturalHeight,
          set_value: parseInt(set_value),
        };
        this.images.push(imageData);
        this.load_end = true;
        await this.draw(this.images.find((a) => a.set_value == this.value));
      };
      imageLoader.src = this.input.customized.images[index];
    },

    async draw(current_image) {
      const canvas = this.$refs.imageSwitchCanvas;
      if (canvas) {
        try {
          const ctx = canvas.getContext("2d");
          await ctx.drawImage(current_image?.image || this.image, 0, 0, canvas.width, canvas.height);

          if (this.input.customized.border) {
            ctx.strokeStyle = this.input.customized.border_color;
            ctx.lineWidth = 8;
            await ctx.strokeRect(0, 0, canvas.width, canvas.height);
          }
        } catch (error) {
          console.log("Error al dibujar la imagen: ", error);
        }
      }
    },

    checkIfImageIsLoaded() {
      if (this.value != undefined) {
        const retrievedImage = this.images.filter((a) => a.set_value == this.value);
        if (retrievedImage.length == 0) {
          const index = this.input.customized.set_values.indexOf(this.value.toString());
          if (index >= 0) this.loadAndDraw(index);
        } else {
          this.draw(retrievedImage[0]);
        }
      }
    },
  },

  mounted() {
    this.input.customized.ignore_plc ? this.loadStaticImage() : this.checkIfImageIsLoaded();
  },

  watch: {
    static_loaded() {
      if (this.static_loaded) this.draw();
    },

    value() {
      if (!this.input.customized.ignore_plc && this.input.customized.images.length > 0) {
        this.checkIfImageIsLoaded();
      }
    },

    input: {
      handler() {
        if (!this.input.customized.ignore_plc && this.input.customized.images.length > 0) {
          this.images = [];
          this.checkIfImageIsLoaded();
        } else {
          this.static_loaded = false;
          this.loadStaticImage();
        }
      },
      deep: true,
    },
  },
};
</script>
